import { Divider } from 'antd'
import * as R from 'ramda'
import React from 'react'

import { Flag } from '../components/countries'

export type EmptyRow = {
  id: string
  isEmpty: true
}

export const emptyRow = (id: string | number) => ({ id, isEmpty: true })

export function renderIfEmpty<T>(
  emptyBranch: React.ReactNode,
  render: (text: any, record: T, index: number) => React.ReactNode,
) {
  return (text: any, record: T & EmptyRow, index: number) =>
    record.isEmpty ? emptyBranch : { children: render ? render(text, record, index) : text }
}

export function skipIfEmpty<T>(render: (text: any, record: T, index: number) => React.ReactNode) {
  return renderIfEmpty(
    {
      children: null,
      props: {
        colSpan: 0,
      },
    },
    render,
  )
}

export const playerColumns = {
  nationality: {
    title: 'Country',
    dataIndex: 'nationality',
    width: '5em',
    render: (countryCode) => <Flag iso2={countryCode} showIso3 />,
  },
  club: {
    title: 'Club',
    dataIndex: 'club',
    width: '5em',
  },
  czechRegistrationId: {
    title: 'ČMGS',
    dataIndex: 'czechRegistrationId',
    width: '5em',
  },
  fullName: {
    title: 'Player',
    key: 'fullName',
    render: (text, record) => `${record.lastName} ${record.firstName}`,
  },
  team: {
    title: 'Team',
    key: 'team',
    width: '10em',
    render: (text, record) =>
      record.team && (
        <span>
          {record.team.name ? record.team.name : record.team.id}
          <Divider type="vertical" />
          {record.team.position}
        </span>
      ),
  },
}

export const resultColumns = {
  sum: {
    title: 'SUM',
    dataIndex: 'totalScore',
    width: '4em',
    className: 'ResultsCol--sum',
  },
  avg: {
    title: 'AVG',
    dataIndex: 'avgScore',
    width: '4em',
    className: 'ResultsCol--avg',
  },
  diff: {
    title: 'DIFF',
    dataIndex: 'diff',
    width: '4em',
    className: 'ResultsCol--diff',
  },
  par: {
    title: 'PAR',
    dataIndex: 'parDiff',
    width: '4em',
    className: 'ResultsCol--par',
  },
}

export const rowParDiffClassName = (record: { parDiff: number }) =>
  R.isNil(record.parDiff) || record.parDiff >= 0 ? 'Results--parOrAbove' : 'Results--belowPar'

const getScoreClassNameByPar = (par: number) => {
  if (par <= -7) {
    return 'Score--best'
  } else if (par >= -6 && par <= -1) {
    return 'Score--good'
  } else if (par >= 0 && par <= 3) {
    return 'Score--average'
  } else {
    return 'Score--bad'
  }
}

export const renderScore = (item?: { parDiff: number; score: number }) =>
  !R.isNil(item) ? <span className={getScoreClassNameByPar(item.parDiff)}>{item.score}</span> : null



// WEBPACK FOOTER //
// ./src/shared/columns.tsx